// @ngInject
function CountriesApiService(ResourcesService) {

  var endpoint = 'countries';

  return {
    getCountries: ResourcesService.apiFactory.get(endpoint),
    getCountryById: ResourcesService.apiFactory.get(endpoint),
    createCountry: ResourcesService.apiFactory.create(endpoint, 'Country'),
    updateCountry: ResourcesService.apiFactory.update(endpoint, 'Country'),
    deleteCountry: ResourcesService.apiFactory.delete(endpoint, 'Country')
  };
}

angular
  .module('countries.api', [])
  .factory('CountriesApiService', CountriesApiService);
